<template>
  <section
    class="gallery-item-photo-pack"
    style="aspect-ratio: 480 / 800; flex-grow: 0.6; "
  >
    <header>
      <h2>{{ searchedBibNumber ? 'Buy this photo pack' : 'Bulk Photo Pack' }}</h2>
    </header>

    <section class="card-body">
      <FontAwesomeIcon
        v-if="isPhotoPackInCart"
        :icon="faCheck"
      />

      <p
        class="message"
        :class="{'text-xl': isPhotoPackInCart}"
      >
        {{ message }}
      </p>

      <p
        v-if="searchedBibNumber && !isPhotoPackInCart"
        class="price"
      >
        {{ 'R' + photoPackPrice.toFixed(2) }}
      </p>

      <input
        v-if="showBuyPhotoPack && !searchedBibNumber"
        v-model="bibNumberSearch"
        type="text"
        placeholder="00000"
        @keyup.enter="$emit('search', formattedBibNumber)"
      >
    </section>

    <footer class="card-footer">
      <AppLink
        v-if="props.isPhotoPackInCart"
        :to="{ name: 'app_cart' }"
        class="btn btn-secondary btn-solid"
      >
        Go to cart
      </AppLink>

      <AppButton
        v-if="searchedBibNumber && !isPhotoPackInCart"
        class="btn-solid btn-secondary"
        :processing="addingPackToCart"
        @click="$emit('addToCart')"
      >
        {{ addingPackToCart ? 'Adding to cart' : 'Add to cart' }}
      </AppButton>

      <AppButton
        v-if="showBuyPhotoPack && !searchedBibNumber"
        class="btn-solid btn-secondary"
        :processing="addingPackToCart"
        @click="$emit('search', formattedBibNumber)"
      >
        Search
      </AppButton>
    </footer>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { AppButton, AppLink } from '@/components/app';

const props = defineProps({
  searchedBibNumber: {
    type: Number,
    default: null,
  },
  photoPackPrice: {
    type: Number,
    default: 0,
  },
  photosCount: {
    type: Number,
    default: 0,
  },
  showBuyPhotoPack: Boolean,
  isPhotoPackInCart: Boolean,
  addingPackToCart: Boolean,
  photos: {
    type: [Array, Object],
    default: () => [],
  },
  previousPhoto: {
    type: Object,
    default: () => {},
  },
});

defineEmits(['addToCart', 'search']);

const bibNumberSearch = defineModel('bibNumberSearch');
const message = computed(() => {
  if (props.showBuyPhotoPack && !props.searchedBibNumber) {
    return 'To buy a bulk photo pack of all your photos, please enter your bib number';
  }

  if (props.searchedBibNumber) {
    if (props.isPhotoPackInCart) {
      return 'This photo pack has been added to your cart';
    } else {
      return `${ props.photosCount } photos found for bib no. ${ props.searchedBibNumber }`;
    }
  }

  return '';
});

const formattedBibNumber = () => {
  // Remove all non-numeric characters
  const numericValue = bibNumberSearch.value.replace(/\D/g, '');
  // Limit to 5 characters
  bibNumberSearch.value.search = numericValue.slice(0, 5);
};

// PHOTO PACK HEIGHT

const imageAspectRatio = computed(() => {
  return props.previousPhoto.thumbnail.dimensions.width / props.previousPhoto.thumbnail.dimensions.height;
});

</script>
